export default __webpack_public_path__ + "static/media/announcer.4e7c5b14.png";